/*
 * Created on Mon Nov 19 2018
 *
 * Copyright (c) 2018 - Francisco Giana <gianafrancisco@gmail.com>
 */
import { Component, OnInit, Input } from '@angular/core';
import { HomeComponent } from './home.component';
import 'rxjs/add/operator/first';

@Component({
    templateUrl: 'deuda.component.html',
    styleUrls: ['home.component.css'],
    selector: 'deuda-row',
})

export class DeudaRowComponent extends HomeComponent implements OnInit {
    @Input() registro: any;
}